module.exports = __webpack_public_path__ + "static/media/groups.ab3f1bcb.svg";